// src/App.js
import React, { useEffect, useState } from "react";
import LoadingScreen from "./components/LoadingScreen";
import logo from "./assets/lsc-logo.svg";
import Home from "./pages/Home";

export default function App() {
  const [showLoader, setShowLoader] = useState(true);
  const [finishLoader, setFinishLoader] = useState(false);

  useEffect(() => {
    const done = () => {
      setTimeout(() => setFinishLoader(true), 1600);
    };

    if (document.readyState === "complete") done();
    else window.addEventListener("load", done, { once: true });

    return () => window.removeEventListener("load", done);
  }, []);

  return (
    <>
      {showLoader && (
        <LoadingScreen
          logoSrc={logo}
          brandName="LSC PRODUTORA"
          finish={finishLoader}
          onDone={() => setShowLoader(false)}
        />
      )}

      <Home />
    </>
  );
}
